// extracted by mini-css-extract-plugin
export default {"container":"Table_container__XPvqi","title":"Table_title__nJAJM","tableContainer":"Table_tableContainer__6U1qq"};